import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/birthday-gifts/")({
  component: lazyRouteComponent(() => import("./-pages/admin.birthday-gifts.index")),
});
